module.exports = __webpack_public_path__ + "img/sicurezza.52125ca6.webp";